import React, { useState, useEffect, useRef } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  Modal,
  ModalBody,
  CustomInput,
} from "reactstrap";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { META_TEMPLATES,META_TEMPLATE_STATUS,PENDING_CHANNELS,DELETE_CHANNEL } from "../../constants";
import axios from "axios";
import NotificationAlert from "react-notification-alert";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from "react-responsive-pagination";
import { useHistory } from "react-router-dom";

const ApprovedWhatsappChannels = () => {
  const [alert, setAlert] = useState(null);
  const [templates, setTemplates] = useState([]);
  const notificationAlertRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [showContent, setShowContent] = useState("");
  const [hoverindex, setHoverindex] = useState(0);



  const navigate = useHistory();

  let lclstrg = localStorage.getItem("user");
  let user = JSON.parse(lclstrg);

  useEffect(() => {
    getApprovedMetaChnl(1);
   // getApprovedChannels(1)
  }, []);

  const getApprovedMetaChnl = (pageNo) => {
    setCurrentPage(pageNo);
    let payload = {
      page: pageNo,
      clientid: user?.client,

      //0->Pending,1->Approve, 2-> Reject
    };
    axios
      .post(META_TEMPLATES,payload)
      .then((res) => {
        console.log("metaresp==>",res.data?.message);
        setTemplates(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        let options = {};
        options = {
          place: "tr",
          message: "Unable to fetch records",
          type: "warning",

          autoDismiss: 2,
        };
        notificationAlertRef?.current.notificationAlert(options);
        console.log(err);
      }).finally(()=>{
        
        setIsLoading(false);
      })
  };

  const getApprovedChannels=(pageNo)=>{
    
    setCurrentPage(pageNo);

    axios.get(PENDING_CHANNELS+ "?page=" + pageNo+"&status=1&client_id="+user?.client).then(res=>{
      console.log("chanl==>",res.data.data);
      setTemplates(res?.data.data)
      setIsLoading(false)
    }).catch((err)=>{
      let options={}
       options = {
        place: "tr",
        message: "Unable to fetch records",
        type: "warning",

        autoDismiss: 2,
      };
      notificationAlertRef?.current.notificationAlert(options);
      console.log(err)})
  }

  const confirmdelete = (id) =>{
    setAlert(<ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => deletetemplate(id)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      >
          You want to remove template ?
      </ReactBSAlert>
      );
  }

  const deletetemplate = (cid) => {
    let options = {};
    setIsLoading(true)
    axios
      .post(DELETE_CHANNEL, { id:cid})
      .then((res) => {
        if(res.status==200){
          setAlert(false)
        options = {
          place: "tr",
          message: "Deleted Successfully",
          type: "success",

          autoDismiss: 2,
        };
        notificationAlertRef.current.notificationAlert(options);
        getApprovedMetaChnl(1);
      }
      })
      .catch((e) => {
        options = {
          place: "tr",
          message: "Unable to Deleted",
          type: "warning",

          autoDismiss: 2,
        };
        notificationAlertRef.current.notificationAlert(options);
      });
  };

const callpendingtemp=(id)=>{
  setIsLoading(true);
  let payload = {
    meta_resp_id: id,
    sender_id: user?.sender_id,

  };
  axios
  .post(META_TEMPLATE_STATUS,payload)
  .then((res) => {
    getApprovedMetaChnl(currentPage)
   // getApprovedChannels(currentPage)
    console.log(res.data);
    setIsLoading(false);
  })
  .catch((err) => {
    let options = {};
    options = {
      place: "tr",
      message: "Unable to fetch records",
      type: "warning",

      autoDismiss: 2,
    };
    notificationAlertRef?.current.notificationAlert(options);
    console.log(err);
  }).finally(()=>{
    
    setIsLoading(false);
  })
}
  return (
    <>
      <div className="content pd-0 ">
        {alert}
        <Row className="Roles">
          <Card>
            <CardBody className="">
              <h3>List of Templates</h3>
              <LoadingScreen
                children=""
                loading={isLoading}
                bgColor="rgba(0,0,0,0.7)"
                spinnerColor="#9ee5f8"
                textColor="#676767"
                logoSrc={logo}
                text="Loading..."
              ></LoadingScreen>
              <NotificationAlert ref={notificationAlertRef} />

              <TableContainer
                component={Paper}
                className="tableheight_nosearch"
              >
              
                <Table
                  sx={{ minWidth: "650px" }}
                  aria-label="simple table"
                  responsive
                  striped
                >
                  <thead>
                    <tr>
                      <th>Sno</th>
                      <th>Template Name</th>
                      <th>Category</th>
                      <th>Status</th>
                      <th>Meta id</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {templates?.message?.length > 0 ? (
                      templates?.message?.map((item, index) => {
                        return (
                          <>
                             {(index==hoverindex&&showModal&&showContent) && (
                                  <div
                                    style={{
                                      zIndex: 999,
                                      borderRadius: 5,
                                      position: "absolute",
                                      maxWidth: "40%",
                                      background: "#a1cb6a",
                                      color: "white",
                                      marginLeft: 200,
                                      marginTop: 0,
                                      cursor:"pointer"
                                    }}
                                  >
                                    <div style={{ padding: 10 }}>
                                     
                                    {showContent}
                                    </div>
                                  </div>
                                )}
                        
                          <tr>
                            <td style={{ width: "5%" }}> {++index}</td>
                            <td style={{ width: "15%",cursor:"pointer" }} onMouseOver={()=>{setShowModal(true);setShowContent(item?.body);setHoverindex(index)}} onMouseLeave={()=>{setShowModal(false);setShowContent("")}} >{item.name}</td>
                            <td style={{ width: "15%", wordBreak: "break-all" }} >
                             {item.category} </td>
                            <td style={{ width: "15%" }} onClick={()=>callpendingtemp(item.meta_resp_id)}> {item.meta_resp_status } {item.meta_resp_status==="PENDING"&&  <i style={{color:"red"}} className="tim-icons icon-refresh-01"  />}</td>
                            <td style={{ width: "30%" }}> {item.meta_resp_id}</td>
                            {/* <td style={{ width: "15%" }} onClick={()=> navigate.push("/admin/whatsapp/viewtemplates",{  data: item})}>
                            view  </td> */}
                            <td>
                            <a to="" className="text-warning ml-2">
                                  <i
                                    className="tim-icons icon-trash-simple"
                                    onClick={() => confirmdelete(item.channel_id)}
                                  ></i>
                                </a>
                            </td>
                          </tr>
                          </>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={6}>No Records Found</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </TableContainer>
            </CardBody>
            {templates?.numOfPages > 0 && (
              <div style={{ marginLeft: "auto", padding: "8px" }}>
                <ResponsivePagination
                  current={currentPage}
                  total={templates?.numOfPages}
                  onPageChange={(newPage) => {
                    getApprovedMetaChnl(newPage);
                //    getApprovedChannels(newPage)
                  }}
                />
              </div>
            )}
          </Card>
        </Row>
      </div>
    </>
  );
};

export default ApprovedWhatsappChannels;
